/**
 * 推送事件到 GTM dataLayer
 * @param {string} eventName - 事件名稱
 * @param {object} eventData - 事件資料
 */
export function pushToDataLayer(eventName, eventData = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData,
    });
    // eslint-disable-next-line no-console
    console.log(eventName, eventData);
  } else {
    // eslint-disable-next-line no-console
    console.warn('dataLayer is not available');
  }
}

